//* Styles
import AwardsContSkeletonStyle from './style';

//* SVG
import { skeleton1, skeleton2, skeleton3, skeleton4, skeleton5 } from './svg';

const AwardsContSkeleton = ({ type }) => {
	return (
		<AwardsContSkeletonStyle>
			{type === 1 ? (
				skeleton5
			) : (
				<div className='home-awards-block'>
					<div className='home-award-item-block'>{skeleton1}</div>

					<div className='home-award-item-block'>{skeleton2}</div>

					<div className='home-award-item-block'>{skeleton3}</div>

					<div className='home-award-item-block'>{skeleton4}</div>
				</div>
			)}
		</AwardsContSkeletonStyle>
	);
};

export default AwardsContSkeleton;
